import { Icon } from '../UI';

export const PlaceholderStrategy = ({
  subtitle,
  title,
}: {
  subtitle: string;
  title: string;
}) => {
  return (
    <div className={'flex flex-col items-center gap-8 py-16'}>
      <Icon svgName="wand" className="w-18 h-18" />
      <span className="font-semibold text-lg w- max-w-full text-center dark:text-white">
        {title}
      </span>
      <span className="text-sm text-grey-50 w-120 max-w-full text-center">
        {subtitle}
      </span>
    </div>
  );
};
